import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getGochiMenusEventData = params =>
  axios.get(`${API_HOST}/menuEvents`, { params, withCredentials: true });

export const getGochiMenuEventDetailData = menuEventId =>
  axios.get(`${API_HOST}/menuEvents/${menuEventId}`, { withCredentials: true });

export const addGochiMenuEventData = params =>
  axios.post(`${API_HOST}/menuEvents`, params, { withCredentials: true });

export const editGochiMenuEventData = (menuEventId, params) =>
  axios.put(`${API_HOST}/menuEvents/${menuEventId}`, params, {
    withCredentials: true
  });

export const changeStatusMenuEventData = (menuEventId, params) =>
  axios.put(`${API_HOST}/menuEvents/${menuEventId}/status`, params, {
    withCredentials: true
  });

export const addGochiMenuEventImageData = (menuEventId, params) =>
  axios.post(`${API_HOST}/menuEvents/${menuEventId}/image`, params, {
    withCredentials: true
  });

export const showHideGochiMenuEventData = (menuEventId, params) =>
  axios.put(`${API_HOST}/menuEvents/${menuEventId}/showHide`, params, {
    withCredentials: true
  });

export const changeEventPriorityData = params =>
  axios.put(`${API_HOST}/gochiEvents/eventOrder`, params, {
    withCredentials: true
  });
